import { render, staticRenderFns } from "./Tab7.vue?vue&type=template&id=7b4e4b62"
import script from "./Tab7.vue?vue&type=script&lang=js"
export * from "./Tab7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports